var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-breadcrumb',[_c('a-breadcrumb-item',{style:({ color: '#000' })},[_c('a-icon',{attrs:{"type":"appstore"}}),_vm._v(" 心理云平台 ")],1),_vm._l((_vm.breadcrumb),function(item){return _c('a-breadcrumb-item',{key:item},[_vm._v(_vm._s(item))])})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }